import React from 'react';
import styled from 'styled-components';

import useCart from 'src/hooks/use-cart';
import { getMinimumInDollars } from 'shared/helpers/dispensaries';
import { formatCurrency } from 'shared/helpers/utils';

type UseBannerReturn = {
  banner: JSX.Element | null;
};

export const useBanner = (): UseBannerReturn => {
  const { dispensary, isDelivery, isEmpty, subtotal } = useCart();

  if (isEmpty) {
    return {
      banner: null,
    };
  }

  const minimum = getMinimumInDollars(isDelivery, dispensary);

  if (!Number.isFinite(subtotal) || !Number.isFinite(minimum) || subtotal > minimum) {
    return {
      banner: null,
    };
  }

  const difference = formatCurrency((minimum as number) - subtotal, { trimZeroCents: true });
  const formattedMinimum = formatCurrency(minimum, { trimZeroCents: true });

  return {
    banner: <MinimumNotMetBanner difference={difference} minimum={formattedMinimum} isDelivery={isDelivery} />,
  };
};

type MinimumNotMetBannerProps = {
  difference: string;
  minimum: string;
  isDelivery: boolean;
};

const MinimumNotMetBanner = ({ difference, minimum, isDelivery }: MinimumNotMetBannerProps): JSX.Element => (
  <BelowMinimumBanner>
    <strong>Add {difference} more</strong> to meet {isDelivery ? 'delivery' : 'pickup'} minimum of {minimum}
  </BelowMinimumBanner>
);

const BelowMinimumBanner = styled.div`
  background: #fae8ea;
  color: #be0517;
  font-size: 13px;
  line-height: 1;
  padding: 8px 16px;
`;
